/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES API 【企業詳細】
 * PR TIMESの企業詳細画面用のAPI
 *
 * The version of the OpenAPI document: 1.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressKitGuidelinesResultsFiles,
    PressKitGuidelinesResultsFilesFromJSON,
    PressKitGuidelinesResultsFilesFromJSONTyped,
    PressKitGuidelinesResultsFilesToJSON,
} from './PressKitGuidelinesResultsFiles';

/**
 * ガイドラインのデータ本体。テキストかファイルがある。
 * @export
 * @interface PressKitGuidelinesResults
 */
export interface PressKitGuidelinesResults {
    /**
     * テキストで書かれたガイドライン。指定がない場合は''
     * @type {string}
     * @memberof PressKitGuidelinesResults
     */
    text: string;
    /**
     * ファイルでまとめられたガイドライン
     * @type {Array<PressKitGuidelinesResultsFiles>}
     * @memberof PressKitGuidelinesResults
     */
    files: Array<PressKitGuidelinesResultsFiles>;
}

export function PressKitGuidelinesResultsFromJSON(json: any): PressKitGuidelinesResults {
    return PressKitGuidelinesResultsFromJSONTyped(json, false);
}

export function PressKitGuidelinesResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitGuidelinesResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'text': json['text'],
        'files': ((json['files'] as Array<any>).map(PressKitGuidelinesResultsFilesFromJSON)),
    };
}

export function PressKitGuidelinesResultsToJSON(value?: PressKitGuidelinesResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'text': value.text,
        'files': ((value.files as Array<any>).map(PressKitGuidelinesResultsFilesToJSON)),
    };
}

